<script setup lang="ts">
    // Bare shared auth layout: runs the common bootstrap (token → tenant → redirect, via useLoadingScreen
    // which routes through useGetGlobalRedirection and already handles the inbound routes), shows the
    // loading gate, then renders a plain slot. Each auth page brings its own chrome via AuthSplitShell /
    // AuthOnboardingShell. Importing useLoadingScreen also warms BaseEndpoint (it imports EndpointFactory),
    // so endpoints are safe to cold-load on these pages.
    const { isLoading, loading, load } = useLoadingScreen(useRoute());
    useMarketingMetrics();

    onMounted(async () => {
        if (load) {
            await load();
        }
    });
</script>

<template>
    <div>
        <transition
            leave-active-class="duration-300 ease-in"
            leave-from-class="opacity-100 blur-none"
            leave-to-class="opacity-0 blur-xl"
        >
            <LayoutLoadingScreen
                v-if="isLoading"
                :loading="loading"
            />
        </transition>
        <template v-if="!isLoading">
            <slot></slot>
        </template>
    </div>
</template>
